<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px"
          class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="八位码" prop="eightBitCode">
                <el-input v-model="queryCondition.eightBitCode" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品名称" prop="eightBitCodeName">
                <el-input v-model="queryCondition.eightBitCodeName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结算单位名称" prop="supplierName">
                <el-input v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Facility名称" prop="facilityName">
                <el-input v-model="queryCondition.facilityName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onSel">选择</el-button>
      </el-row>
      <el-table ref="multipleTable" :data="tableData" @selection-change="handleSelectionChange" border
        style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="eightBitCode" label="产品编号"></el-table-column>
        <el-table-column prop="eightBitCodeName" label="产品名称"></el-table-column>
        <el-table-column prop="supplierName" label="结算单位名称"></el-table-column>
        <el-table-column prop="facilityName" label="Facility名称"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize"
          :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="showDetailDialog" append-to-body width="80%" :close-on-click-modal="false"
      @close="closeDialog">
      <detailDialog v-if="showDetailDialog"></detailDialog>
    </el-dialog>
  </div>
</template>
<script>
import StockRecoveryApi from "@/api/StockRecovery/index";
import commonFunction from "@/utils/dataTableUtils";
export default {
  name: '',
  components: {
  },
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      eightBitCodeLists: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        eightBitCode: "",
        eightBitCodeName: "",
        supplierName: "",
        facilityName: "",
      },
      totalCount: 0,
      pages: 1,
      checkedVal: null,
    }
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      StockRecoveryApi.getfindEightBitListPage(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
      });
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.eightBitCodeLists = []
      val.forEach(ele => {
        this.eightBitCodeLists.push(ele.eightBitCode)
      })
    },
    onSel() {
      console.log('eightBitCodeLists', this.eightBitCodeLists);
      if (this.eightBitCodeLists.length === 0) {
        this.$my_message('请选择操作数据', 'error');
        return false
      }
      var arr = []
      this.tableData.forEach(ele => {
        if (this.eightBitCodeLists.includes(ele.eightBitCode)) {
          arr.push(ele)
        }
      })
      console.log('arr', arr);
      this.$emit('setSelPro', JSON.stringify(arr))
      this.$refs.multipleTable.clearSelection();
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        eightBitCode: "",
        eightBitCodeName: "",
        supplierName: "",
        facilityName: "",
      }
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped ></style>
